import { Grid, Tooltip } from "@material-ui/core";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import IconDelete from "app/common/Icon/IconDelete";
import { pagingStaff } from "app/services/StaffService";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { forwardRef, memo, useEffect } from "react";
import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
import { pagingPosition } from "app/services/PositionService";
import CommonButton from "app/common/Component/Button/CommonButton";
import { ArrowDownward } from "@material-ui/icons";
import { getPositionCodes, IconDescription } from "app/common/LocalFunction";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { renderOptionsStaff } from "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationSearch";
import { LEAD_SOURCE_LEVEL, POPUP_TYPE_CHANGE_CARD, POPUP_TYPE_CHANGE_PRODUCT, POPUP_TYPE_CHANGE_SERVICE, POPUP_TYPE_CHANGE_TREATMENT, STAFF_REVENUE_STATUS } from "app/common/LocalConst";
import GlobitsVNDCurrencyInputOnlyChange from "app/common/form/GlobitsVNDCurrencyInputOnlyChange";
import { EXCLUDE_QUIT_STAFF } from "app/appConfig";

function RegisterChangeTreatmentStaffsRevenue({
  handleAddStaff,
  totalAmount = 0,
  isDisabled,
  popupChangeType = 0, // 1, 2 là liệu trình thẻ , 3 dịch vụ , 4 sản phẩm 
}) {
  let POSITION_CODES = getPositionCodes();
  const { initialValues, values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (
      values?.paServiceRegister?.length > 0 ||
      values?.drugs?.length > 0 ||
      (values?.defaultCard && values?.clientCard)
    ) {
      const dataTotalAmount =
        totalAmount - (values?.oldTreatmentCredit || values?.oldCredit || 0);

      const { percentDifferenceOld, percentRevenueNew } =
        handleCalPercentRevenue(dataTotalAmount);

      let newStaffRevenues = [
        ...(values?.staffRevenues?.length > 0 ? values?.staffRevenues : []),
      ];

      const staffRevenues = newStaffRevenues?.map((el) => {
        if (el?.originTreatmentId) {
          //xử lí tk cũ
          let percentRevenue =
            percentDifferenceOld * el?.oldPercentRevenue > 100
              ? 100
              : percentDifferenceOld * el?.oldPercentRevenue;
          return {
            ...el,
            percentRevenue,
            actualAmount: ((percentRevenue * dataTotalAmount) / 100).toFixed(4),
          };
        } else {
          let percentRevenue = percentRevenueNew > 0 ? percentRevenueNew : 0;

          return {
            ...el,
            percentRevenue,
            actualAmount: ((percentRevenue * dataTotalAmount) / 100).toFixed(4),
          };
        }
      });
      setFieldValue("staffRevenues", staffRevenues);
    }
  }, [totalAmount, values?.oldCredit, values?.oldTreatmentCredit]);

  const handleCalPercentRevenue = (dataTotalAmount) => {
    if (!(dataTotalAmount > 1)) {
      return {
        percentDifferenceOld: 100,
        percentRevenueNew: 100,
      };
    }
    let percentDifferenceOld;
    let percentRevenueNew; //cth tính doanh thu dựa trên đã trả tiền hay chưa
    //nếu chưa trả thì lấy tiền phải trả / tổng để tính % ông cũ,
    // ông mới thì lấy tổng cần thu -  phải trả / tổng cần thu
    let totalBillPatientPaid =
      values?.oldTreatmentPlanCard?.totalBillPatientPaid ||
      values?.oldPatientServiceRegister?.totalBillPatientPaid ||
      values?.oldProduct?.totalBillPatientPaid ||
      0;

    let amountActuallyPaid =
      values?.oldTreatmentPlanCard?.amountActuallyPaid ||
      values?.oldPatientServiceRegister?.amountActuallyPaid ||
      values?.oldProduct?.amountActuallyPaid ||
      0;
    if (totalBillPatientPaid > 0) {
      const remaining = amountActuallyPaid - totalBillPatientPaid || 0;
      percentDifferenceOld = remaining / dataTotalAmount;

      percentRevenueNew =
        ((dataTotalAmount - remaining) / dataTotalAmount) * 100;
    } else {
      percentDifferenceOld = amountActuallyPaid / dataTotalAmount;
      percentRevenueNew =
        ((dataTotalAmount - amountActuallyPaid) / dataTotalAmount) * 100;
    }
    return {
      percentDifferenceOld,
      percentRevenueNew,
    };
  };

  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  // xác định nguồn new
  const newSource =
    values?.newTreatmentPlanCard ||
    values?.newPatientServiceRegister ||
    values?.newProduct ||
    values; // form đổi là new_

  const voucherIds = Array.isArray(newSource?.voucherAllocations)
    ? newSource?.voucherAllocations
      .map(item => item?.voucher?.id)
      .filter(Boolean)
    : [];

  const invoiceItemIds = Array.isArray(newSource?.invoiceItemAllocations)
    ? newSource?.invoiceItemAllocations
      .map(item => item?.invoiceItem?.id)
      .filter(Boolean)
    : [];

  const sourceRevenueCondition = {
    startDate: values?.startDate || values?.orderDate || newSource?.startDate || newSource?.orderDate,
    patientId: patientId,
    voucherIds: voucherIds,
    invoiceItemIds: invoiceItemIds
  }
  console.log("newSource", values)
  return (
    <FieldArray name="staffRevenues">
      {({ remove, push }) => (
        <>
          <Grid item xs={12} sm={2}>
            <GlobitsPagingAutocomplete
              label={"Nguồn"}
              name="sourceRevenue"
              api={pagingCustomerSource}
              isDisabled={isDisabled}
              searchObject={{
                level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                ...sourceRevenueCondition,
                departmentId: values?.department?.id || newSource?.department?.id,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <GlobitsPagingAutocomplete
              label={"Chọn chức danh"}
              name="position"
              api={pagingPosition}
              searchObject={{
                isUsing: true,
                positionCodes: POSITION_CODES,
              }}
              isDisabled={isDisabled}
            />
          </Grid>
          <Grid item xs={10} sm={3}>
            <GlobitsPagingAutocomplete
              label={"Chọn nhân viên được phân bổ doanh thu"}
              api={pagingStaff}
              name={`staff`}
              displayLabel="staffName"
              autoUpercase
              isDisabled={isDisabled}
              searchObject={{
                positionId: values?.position?.id,
                isActive: true,
                excludeStatus: EXCLUDE_QUIT_STAFF
              }}
              getOptionDisabled={(option) => {
                const selectedService = getIn(values, "staffRevenues") || [];
                if (
                  selectedService?.find((it) => it?.staff?.id === option?.id)
                ) {
                  return false;
                }
                return false;
              }}
              ListboxComponent={forwardRef((props, ref) => {
                const { children, ...other } = props;
                return (
                  <ul {...other} ref={ref}>
                    <ol>
                      <li>{children}</li>
                    </ol>
                  </ul>
                );
              })}
              renderOption={(option) => renderOptionsStaff(option)}
            />
          </Grid>
          <Grid item xs={1} className="flex  align-end">
            <CommonButton
              disabled={isDisabled}
              onClick={() => {
                if (handleAddStaff) {
                  handleAddStaff({
                    staff: values?.staff,
                    position: values?.position
                      ? values?.position
                      : values?.staff?.position,
                    source: values?.sourceRevenue,
                    // percentRevenue: 100,
                    // actualAmount: totalAmount,
                  });
                  setFieldValue("staff", null);
                  setFieldValue("position", null);
                  return;
                }
                push({
                  staff: values?.staff,
                  position: values?.position
                    ? values?.position
                    : values?.staff?.position,
                  source: values?.sourceRevenue,
                  percentRevenue: 100,
                  actualAmount: totalAmount || 0,
                });
                setFieldValue("staff", null);
                setFieldValue("position", null);
              }}
            >
              <ArrowDownward />
            </CommonButton>
          </Grid>
          <Grid item xs={12} md={3} className="flex align-end">
            <IconDescription list={STAFF_REVENUE_STATUS} />
          </Grid>

          <Grid item xs={12}>
            <div className="table-root">
              <div style={{ minWidth: "800px" }}>
                <table className="table-container">
                  <thead>
                    <tr className="row-table-header">
                      <th width="5%">STT</th>
                      <th width="10%">Thao tác</th>
                      <th width="17%">Nguồn</th>
                      <th width="20%">Chức danh</th>
                      <th width="18%">Nhân viên</th>
                      <th width="15%">Phân bổ doanh thu (%)</th>
                      <th width="15%">Phân bổ doanh thu (tiền)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values?.staffRevenues?.length > 0 &&
                      values?.staffRevenues?.map((item, index) => {
                        let positionName =
                          values?.staffRevenues[index]?.position?.name;
                        let staffName =
                          values?.staffRevenues[index]?.staff?.staffName;

                        if (!positionName) {
                          positionName = "Chưa lựa chọn";
                        }
                        if (!staffName) {
                          staffName = "Chưa lựa chọn";
                        }

                        return (
                          <tr
                            key={index}
                            className={`${item?.originTreatmentId
                              ? "old-staff"
                              : "new-staff"
                              }`}
                          >
                            <td align="center">{index + 1}</td>
                            <td align="center">
                              <span
                                tooltip={"Xóa"}
                                className="pointer tooltip"
                                onClick={() => remove(index)}
                              >
                                <IconDelete />
                              </span>
                            </td>
                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingCustomerSource}
                                name={`staffRevenues[${index}].source`}
                                autoUpercase
                                disabled={isDisabled}
                                searchObject={{
                                  level: 2,
                                  ...sourceRevenueCondition,
                                  departmentId: values?.department?.id || newSource?.department?.id,
                                }}
                              />
                            </td>
                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingPosition}
                                name={`staffRevenues[${index}].position`}
                                autoUpercase
                                searchObject={{
                                  isUsing: true,
                                  positionCodes: POSITION_CODES,
                                }}
                                handleChange={function (_, value) {
                                  setFieldValue(
                                    `staffRevenues[${index}].position`,
                                    value
                                  );
                                  setFieldValue(
                                    `staffRevenues[${index}].staff`,
                                    null
                                  );
                                }}
                                disabled={isDisabled}
                              />
                            </td>

                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingStaff}
                                name={`staffRevenues[${index}].staff`}
                                displayLabel={"staffName"}
                                autoUpercase
                                searchObject={{
                                  positionId: values?.staffRevenues[index]?.position?.id,
                                  isActive: true,
                                  excludeStatus: EXCLUDE_QUIT_STAFF
                                }}
                                disabled={isDisabled}
                              />
                            </td>
                            <td>
                              <GlobitsNumberInput
                                name={`staffRevenues[${index}].percentRevenue`}
                                onChange={(e) => {
                                  const percentRevenue = +e?.target?.value;
                                  setFieldValue(
                                    `staffRevenues[${index}].percentRevenue`,
                                    percentRevenue
                                  );
                                  const dataTotalAmount =
                                    totalAmount -
                                    (values?.oldTreatmentCredit ||
                                      values?.oldCredit ||
                                      0);

                                  setFieldValue(
                                    `staffRevenues[${index}].actualAmount`,
                                    (percentRevenue * dataTotalAmount) / 100
                                  );
                                }}
                                disabled={isDisabled}
                              />
                            </td>
                            <td>
                              <GlobitsVNDCurrencyInputOnlyChange
                                isOnlyOnChange
                                name={`staffRevenues[${index}].actualAmount`}
                                disabled={isDisabled}
                                onChange={(e) => {
                                  const actualAmount = +e?.target?.value;
                                  setFieldValue(
                                    `staffRevenues[${index}].actualAmount`,
                                    actualAmount
                                  );
                                  const dataTotalAmount =
                                    totalAmount -
                                    (values?.oldTreatmentCredit ||
                                      values?.oldCredit ||
                                      0);

                                  setFieldValue(
                                    `staffRevenues[${index}].percentRevenue`,
                                    (actualAmount / dataTotalAmount) * 100
                                  );
                                }}
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </Grid>
        </>
      )}
    </FieldArray>
  );
}

export default memo(observer(RegisterChangeTreatmentStaffsRevenue));
